"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateProductSelection = validateProductSelection;
const property_1 = require("@genesys/property");
function validateProductSelection(properties, selectedProperties) {
    const allValid = properties.every(property => {
        const selectedValue = property_1.PropertyValueSet.getValue(property.name, selectedProperties);
        const selectedValueItem = property.value &&
            property.value.find(value => (value.value === undefined && selectedValue === undefined) ||
                (value.value && property_1.PropertyValue.equals(selectedValue, value.value)));
        switch (getPropertyType(property.quantity)) {
            case "integer": {
                const isValid = selectedValueItem
                    ? property_1.PropertyFilter.isValid(selectedProperties, selectedValueItem.property_filter)
                    : false;
                return isValid;
            }
            case "amount": {
                const isValid = property.validation_filter &&
                    property_1.PropertyFilter.isValid(selectedProperties, property.validation_filter);
                return isValid;
            }
            default: {
                return true;
            }
        }
    });
    return allValid;
}
function getPropertyType(quantity) {
    switch (quantity) {
        case "Text":
            return "text";
        case "Discrete":
            return "integer";
        default:
            return "amount";
    }
}
//# sourceMappingURL=validate-product-selection.js.map